import { NotificationType, NotificationCategory, NotificationPriority } from './notification-hub.types';

type NotificationHubEntry = {
  category: NotificationCategory;
  priority: NotificationPriority;
};

export const NOTIFICATION_HUB_CONFIG: Partial<Record<NotificationType, NotificationHubEntry>> = {
  // === CSV Import ===
  [NotificationType.CSV_IMPORT_COMPLETED]: {
    category: NotificationCategory.ORDERS,
    priority: NotificationPriority.INFO,
  },
  [NotificationType.CSV_IMPORT_COMPLETED_WITH_WARNINGS]: {
    category: NotificationCategory.ORDERS,
    priority: NotificationPriority.WARNING,
  },
  [NotificationType.CSV_IMPORT_FAILED]: {
    category: NotificationCategory.ORDERS,
    priority: NotificationPriority.CRITICAL,
  },

  // === Orders Import ===
  [NotificationType.ORDERS_IMPORTED]: {
    category: NotificationCategory.ORDERS,
    priority: NotificationPriority.INFO,
  },

  // === Customers Import ===
  [NotificationType.CUSTOMERS_IMPORTED]: {
    category: NotificationCategory.ORDERS,
    priority: NotificationPriority.INFO,
  },
  [NotificationType.CUSTOMERS_IMPORT_FAILED]: {
    category: NotificationCategory.ORDERS,
    priority: NotificationPriority.CRITICAL,
  },

  // === Orders Export ===
  [NotificationType.ORDERS_EXPORT_STARTED]: {
    category: NotificationCategory.ORDERS,
    priority: NotificationPriority.INFO,
  },
  [NotificationType.ORDERS_EXPORT_COMPLETED]: {
    category: NotificationCategory.ORDERS,
    priority: NotificationPriority.INFO,
  },
  [NotificationType.ORDERS_EXPORT_FAILED]: {
    category: NotificationCategory.ORDERS,
    priority: NotificationPriority.WARNING,
  },

  // === Shipments Export ===
  [NotificationType.SHIPMENTS_EXPORT_STARTED]: {
    category: NotificationCategory.SHIPPING,
    priority: NotificationPriority.INFO,
  },
  [NotificationType.SHIPMENTS_EXPORT_COMPLETED]: {
    category: NotificationCategory.SHIPPING,
    priority: NotificationPriority.INFO,
  },
  [NotificationType.SHIPMENTS_EXPORT_FAILED]: {
    category: NotificationCategory.SHIPPING,
    priority: NotificationPriority.WARNING,
  },

  // === Freight Export ===
  [NotificationType.FREIGHT_EXPORT_STARTED]: {
    category: NotificationCategory.SHIPPING,
    priority: NotificationPriority.INFO,
  },
  [NotificationType.FREIGHT_EXPORT_COMPLETED]: {
    category: NotificationCategory.SHIPPING,
    priority: NotificationPriority.INFO,
  },
  [NotificationType.FREIGHT_EXPORT_FAILED]: {
    category: NotificationCategory.SHIPPING,
    priority: NotificationPriority.WARNING,
  },

  // === Product Import ===
  [NotificationType.PRODUCT_IMPORT_COMPLETED]: {
    category: NotificationCategory.INVENTORY,
    priority: NotificationPriority.INFO,
  },
  [NotificationType.PRODUCT_ALIAS_IMPORT_COMPLETED]: {
    category: NotificationCategory.INVENTORY,
    priority: NotificationPriority.INFO,
  },
  [NotificationType.PRODUCT_BUNDLES_IMPORT_COMPLETED]: {
    category: NotificationCategory.INVENTORY,
    priority: NotificationPriority.INFO,
  },
  [NotificationType.PRODUCT_IMPORT_FAILED]: {
    category: NotificationCategory.INVENTORY,
    priority: NotificationPriority.CRITICAL,
  },

  // === Product Export ===
  [NotificationType.PRODUCT_EXPORT_COMPLETED]: {
    category: NotificationCategory.INVENTORY,
    priority: NotificationPriority.INFO,
  },
  [NotificationType.PRODUCT_EXPORT_FAILED]: {
    category: NotificationCategory.INVENTORY,
    priority: NotificationPriority.WARNING,
  },

  // === Inventory Import ===
  [NotificationType.INVENTORY_IMPORT_COMPLETED]: {
    category: NotificationCategory.INVENTORY,
    priority: NotificationPriority.INFO,
  },
  [NotificationType.INVENTORY_IMPORT_FAILED]: {
    category: NotificationCategory.INVENTORY,
    priority: NotificationPriority.CRITICAL,
  },

  // === Inventory Export ===
  [NotificationType.INVENTORY_EXPORT_COMPLETED]: {
    category: NotificationCategory.INVENTORY,
    priority: NotificationPriority.INFO,
  },
  [NotificationType.INVENTORY_EXPORT_FAILED]: {
    category: NotificationCategory.INVENTORY,
    priority: NotificationPriority.WARNING,
  },

  // === Locations Export ===
  [NotificationType.LOCATIONS_EXPORT_STARTED]: {
    category: NotificationCategory.INVENTORY,
    priority: NotificationPriority.INFO,
  },
  [NotificationType.LOCATIONS_EXPORT_COMPLETED]: {
    category: NotificationCategory.INVENTORY,
    priority: NotificationPriority.INFO,
  },
  [NotificationType.LOCATIONS_EXPORT_FAILED]: {
    category: NotificationCategory.INVENTORY,
    priority: NotificationPriority.WARNING,
  },

  // === Totes Export ===
  [NotificationType.TOTES_EXPORT_STARTED]: {
    category: NotificationCategory.INVENTORY,
    priority: NotificationPriority.INFO,
  },
  [NotificationType.TOTES_EXPORT_COMPLETED]: {
    category: NotificationCategory.INVENTORY,
    priority: NotificationPriority.INFO,
  },
  [NotificationType.TOTES_EXPORT_FAILED]: {
    category: NotificationCategory.INVENTORY,
    priority: NotificationPriority.WARNING,
  },

  // === Forecasting Export ===
  [NotificationType.FORECASTING_EXPORT_FAILED]: {
    category: NotificationCategory.INVENTORY,
    priority: NotificationPriority.WARNING,
  },

  // === Fulfillments Export ===
  [NotificationType.FULFILLMENTS_EXPORT_STARTED]: {
    category: NotificationCategory.SHIPPING,
    priority: NotificationPriority.INFO,
  },
  [NotificationType.FULFILLMENTS_EXPORT_COMPLETED]: {
    category: NotificationCategory.SHIPPING,
    priority: NotificationPriority.INFO,
  },
  [NotificationType.FULFILLMENTS_EXPORT_FAILED]: {
    category: NotificationCategory.SHIPPING,
    priority: NotificationPriority.WARNING,
  },

  // === Transaction History Export ===
  [NotificationType.TRANSACTION_HISTORY_EXPORT_STARTED]: {
    category: NotificationCategory.BILLING,
    priority: NotificationPriority.INFO,
  },
  [NotificationType.TRANSACTION_HISTORY_EXPORT_COMPLETED]: {
    category: NotificationCategory.BILLING,
    priority: NotificationPriority.INFO,
  },
  [NotificationType.TRANSACTION_HISTORY_EXPORT_FAILED]: {
    category: NotificationCategory.BILLING,
    priority: NotificationPriority.WARNING,
  },

  // === Returns Export ===
  [NotificationType.RETURNS_EXPORT_COMPLETED]: {
    category: NotificationCategory.SHIPPING,
    priority: NotificationPriority.INFO,
  },
};
